/**
 * Vehicle odometer change reason values
 */
export enum VehicleOdometerChangeReasonEnum {
	INITIAL = 'initial',
	TRANSFER = 'transfer',
	CORRECTION = 'correction',
	CHECK_IN = 'check-in',
	CHECK_OUT = 'check-out',
	TRACKER_READING = 'tracker-reading',
}
